import {useNavigate} from 'react-router-dom'
import {Button, Center, Text} from '@chakra-ui/react'
import {PATH} from '@utils/Const'
import {CommonColors} from '@utils/CommonStyles'

export const NotFoundResult = () => {
  const navigate = useNavigate()
  return (
    <Center
      flexDirection={'column'}
      h={'100vh'}
      alignItems={'center'}
      justifyContent={'center'}
      bg={CommonColors.backgroundBase}>
      <Text fontWeight={'700'} fontSize={'100px'}>
        404
      </Text>
      <Text fontSize={'24px'}>Page Not Found</Text>
      <Button
        fontSize={'20px'}
        mt={'24px'}
        onClick={() => navigate(PATH.HOME, {replace: true})}
        color={'white'}
        bg={CommonColors.primary}
        _hover={{bg: '#006ed4'}}>
        Go home
      </Button>
    </Center>
  )
}
